import { useId, useRef } from 'react';
import { useDialogFocus } from '../config/ConfigHistoryDialog';

export interface ChangeLine {
  label: string;
  from: string;
  to: string;
}

/**
 * #1113 — the confirm a risky Finance-card save asks first (fee turned on, fee type changed, Tabby
 * customer switch flipped): a title, the consequence, and every change old → new.
 * Cancel writes nothing. Focus starts on Cancel; Escape and a click outside cancel too.
 */
export default function ConfirmChangesDialog({
  title,
  body,
  confirmLabel,
  changes,
  onCancel,
  onConfirm,
}: {
  title: string;
  body: string;
  confirmLabel: string;
  changes: ChangeLine[];
  onCancel: () => void;
  onConfirm: () => void;
}) {
  const titleId = useId();
  const bodyId = useId();
  const cancelRef = useRef<HTMLButtonElement>(null);
  useDialogFocus(cancelRef, onCancel);

  return (
    <div className="admin-modal-overlay" onClick={onCancel}>
      <div
        className="admin-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby={titleId}
        aria-describedby={bodyId}
        onClick={(e) => e.stopPropagation()}
        data-testid="confirm-changes-dialog"
      >
        <div className="admin-modal-header">
          <h3 id={titleId}>{title}</h3>
        </div>
        <div className="admin-modal-body config-dialog-body">
          <p id={bodyId} style={{ margin: 0 }}>{body}</p>
          <div>
            <div className="config-hint" style={{ marginBottom: 4 }}>You are saving these changes:</div>
            <ul className="config-diff">
              {changes.map((c) => (
                <li key={c.label}>
                  <span>{c.label}</span>
                  <span>
                    <span className="config-diff-from">{c.from}</span>
                    {' → '}
                    <span className="config-diff-to">{c.to}</span>
                  </span>
                </li>
              ))}
            </ul>
          </div>
        </div>
        <div className="admin-modal-footer">
          <button ref={cancelRef} type="button" className="admin-btn admin-btn-outline" onClick={onCancel}>Cancel</button>
          <button type="button" className="admin-btn admin-btn-primary" onClick={onConfirm}>{confirmLabel}</button>
        </div>
      </div>
    </div>
  );
}
